module.exports = __webpack_public_path__ + "static/media/plan-mas-400gb.083e07bc.svg";